import {handleActions} from 'redux-actions'
import * as ActionTypes from "./actionTypes"
import {CLOSE_ALL_PANELS} from '../../../administration/userManagement/common/actionTypes'

const initialState = {
    userId: null,
    showCopyContent: false,
    copyContent: {
        userId: null,
        loading: false,
        usersForSelector: [],
        userFromAssignedUsers: [],
    },
}

export default handleActions({
    [ActionTypes.TEAM_ASSIGNMENTS_PANEL_USER_ID_SET]: (state, {payload: userId}) => ({
        ...state,
        userId: userId,
        showCopyContent: false,
        copyContent: {
            userId: null,
            loading: false,
            usersForSelector: [],
            userFromAssignedUsers: [],
        },
    }),
    [ActionTypes.COPY_CONTENT_OPEN] : (state) => ({
        ...state,
        showCopyContent: true,
        copyContent: {
            ...state.copyContent,
            userId: null,
            loading: false,
        },
    }),
    [ActionTypes.COPY_CONTENT_CLOSE] : (state) => ({
        ...state,
        showCopyContent: false,
    }),
    [ActionTypes.COPY_USER_ID_SET]: (state, {payload: userId}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            userId,
        }
    }),
    [ActionTypes.COPY_LOADING_SET]: (state, {payload: loading}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            loading,
        }
    }),
    [ActionTypes.USER_FROM_ASSIGNED_USERS_SET]: (state, {payload: userFromAssignedUsers}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            userFromAssignedUsers,
        }
    }),
    [ActionTypes.COPY_USERS_FOR_SELECTOR_SET]: (state, {payload: usersForSelector}) => ({
        ...state,
        copyContent: {
            ...state.copyContent,
            usersForSelector,
        }
    }),
    [CLOSE_ALL_PANELS]: (state) => ({
        ...state,
        userId: null,
        showCopyContent: false,
        copyContent: {
            userId: null,
            loading: false,
            usersForSelector: [],
            userFromAssignedUsers: [],
        },
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/panels/user/editTeamAssignmentsPanel/reducer.js